import * as React from 'react';
import { Image, Text, View } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { MapStack } from "./MapStack";
import { DeliveryStack } from "./DeliveryStack";
import { MoreStack } from "./MoreStack";
import { ExploreStack } from "./ExploreStack";
import * as SplashScreen from 'expo-splash-screen';
import { useSelector, useDispatch } from 'react-redux';

const Tab = createBottomTabNavigator();

export function HomepageAuthenticated() {
  const [appLoading, setAppLoading] = React.useState(0);
  const dispatch = useDispatch();
  const showTabs = useSelector((state) => state.showTabs);

  const onLayoutRootView = React.useCallback(async () => {
    if (appLoading == 0) {
      try {
        if (!AppUtilities.isWeb()) {
          AppUtilities.info("HomepageAuthenticated.onLayoutRootView Hiding splash screen");
          await SplashScreen.hideAsync();
        }
      } catch (e) {
        AppUtilities.handleException(e, "HomepageAuthenticated.onLayoutRootView");
      }

      setAppLoading(1);
    }
  }, [appLoading]);

  const tabProps = {};
  if (!showTabs) {
    tabProps.tabBar = (props) => null;
  }

  return (
    <View style={AppConstants.STYLES.flex1} onLayout={onLayoutRootView}>
      <Tab.Navigator
        screenOptions={({ navigation, route }) => ({
          headerRight: AppUtilities.getHeaderRight(navigation),
          headerTitle: (props) => <Text selectable={true} {...props} style={AppConstants.STYLES.fontSize17} />,
          tabBarLabelPosition: "below-icon",
          lazy: true,
        })}
        {...tabProps}
      >
        <Tab.Screen
          name={AppConstants.SCREENS.MAP_STACK}
          component={MapStack}
          options={{
            title: "Map",
            // https://icons.expo.fyi/Index/MaterialCommunityIcons/map-marker
            /*
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 24 label:󰍎 assets/map-marker-blue.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 48 label:󰍎 assets/map-marker-blue@2x.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 96 label:󰍎 assets/map-marker-blue@3x.png

            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 24 label:󰍎 assets/map-marker-grey.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 48 label:󰍎 assets/map-marker-grey@2x.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 96 label:󰍎 assets/map-marker-grey@3x.png
            */
            tabBarIcon: ({ focused, color, size }) => {
              return focused ? <Image source={require('../../assets/map-marker-blue.png')} style={AppConstants.STYLES.image25x25} /> : <Image source={require('../../assets/map-marker-grey.png')} style={AppConstants.STYLES.image25x25} />;
            },
            headerShown: false
          }}
          listeners={({ navigation, route }) => ({
            tabPress: (e) => {
              dispatch(AppState.createDispatch(AppConstants.DISPATCH.SET_LAST_MAIN_VIEW, AppConstants.SCREENS.MAP_STACK));
            },
          })}
        />
        <Tab.Screen
          name={AppConstants.SCREENS.DELIVERY_STACK}
          component={DeliveryStack}
          options={{
            title: "Delivery",
            // https://icons.expo.fyi/Index/MaterialCommunityIcons/package-variant-closed
            /*
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 24 label:󰏗 assets/package-variant-closed-blue.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 48 label:󰏗 assets/package-variant-closed-blue@2x.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 96 label:󰏗 assets/package-variant-closed-blue@3x.png

            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 24 label:󰏗 assets/package-variant-closed-grey.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 48 label:󰏗 assets/package-variant-closed-grey@2x.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf -pointsize 96 label:󰏗 assets/package-variant-closed-grey@3x.png
            */
            tabBarIcon: ({ focused, color, size }) => {
              return focused ? <Image source={require('../../assets/package-variant-closed-blue.png')} style={AppConstants.STYLES.image25x25} /> : <Image source={require('../../assets/package-variant-closed-grey.png')} style={AppConstants.STYLES.image25x25} />;
            },
            headerShown: false,
          }}
          listeners={({ navigation, route }) => ({
            tabPress: (e) => {
              dispatch(AppState.createDispatch(AppConstants.DISPATCH.SET_LAST_MAIN_VIEW, AppConstants.SCREENS.DELIVERY_STACK));
            },
          })}
        />
        <Tab.Screen
          name={AppConstants.SCREENS.EXPLORE_STACK}
          component={ExploreStack}
          options={{
            title: "Explore",
            // https://icons.expo.fyi/Index/AntDesign/find
            /*
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf -pointsize 24 label: assets/find-blue.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf -pointsize 48 label: assets/find-blue@2x.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf -pointsize 96 label: assets/find-blue@3x.png

            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf -pointsize 24 label: assets/find-grey.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf -pointsize 48 label: assets/find-grey@2x.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/AntDesign.ttf -pointsize 96 label: assets/find-grey@3x.png
            */
            tabBarIcon: ({ focused, color, size }) => {
              return focused ? <Image source={require('../../assets/find-blue.png')} style={AppConstants.STYLES.image25x25} /> : <Image source={require('../../assets/find-grey.png')} style={AppConstants.STYLES.image25x25} />;
            },
            headerShown: false,
          }}
          listeners={({ navigation, route }) => ({
            tabPress: (e) => {
              dispatch(AppState.createDispatch(AppConstants.DISPATCH.SET_LAST_MAIN_VIEW, AppConstants.SCREENS.EXPLORE_STACK));
            },
          })}
        />
        <Tab.Screen
          name={AppConstants.SCREENS.MORE_STACK}
          component={MoreStack}
          options={{
            title: "More",
            // https://icons.expo.fyi/Index/Ionicons/ellipsis-horizontal-circle
            /*
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf -pointsize 24 label: assets/ellipsis-horizontal-circle-blue.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf -pointsize 48 label: assets/ellipsis-horizontal-circle-blue@2x.png
            convert -background none -fill "#007AFF" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf -pointsize 96 label: assets/ellipsis-horizontal-circle-blue@3x.png

            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf -pointsize 24 label: assets/ellipsis-horizontal-circle-grey.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf -pointsize 48 label: assets/ellipsis-horizontal-circle-grey@2x.png
            convert -background none -fill "#8f9bb3" -font ./node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf -pointsize 96 label: assets/ellipsis-horizontal-circle-grey@3x.png
            */
            tabBarIcon: ({ focused, color, size }) => {
              return focused ? <Image source={require('../../assets/ellipsis-horizontal-circle-blue.png')} style={AppConstants.STYLES.image25x25} /> : <Image source={require('../../assets/ellipsis-horizontal-circle-grey.png')} style={AppConstants.STYLES.image25x25} />;
            },
            headerShown: false,
            lazy: false,
          }}
          listeners={({ navigation, route }) => ({
            tabPress: (e) => {
              //dispatch(AppState.createDispatch(AppConstants.DISPATCH.SET_LAST_MAIN_VIEW, AppConstants.SCREENS.MORE_STACK));
            },
          })}
        />
      </Tab.Navigator>
    </View>
  );
}
